import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import Icon from './Icon'
import style from './Header.less'

class Header extends Component {
    static propTypes = {
        status: PropTypes.string,
        help: PropTypes.node
    }

    render() {
        const {children, status, help} = this.props
        var statusClass = status && status.toLowerCase()

        return (
            <div className={cx(style.default, style[statusClass])}>
                <div className={style.main}>
                    <div className={style.container}>
                        {children}
                    </div>
                    {status && (
                        <div className={style.status}>
                            <Icon icon={'status-' + statusClass} size='xs' />
                        </div>
                    )}
                </div>
                {help && (
                    <div className={style.side}>
                        {help}
                    </div>
                )}
            </div>
        )
    }
}

export default Header


// WEBPACK FOOTER //
// ./lib/core/components/Header.js